<template>
  <div class="row">
    <div class="form-group col-md-12">
      <div class="card">
        <div class="card-header">
          <span>{{ $t('event.form.project.title') }}</span>
          
          <div class="float-right" >
            <a href="#eventProject" name="eventProject" @click="addEventProject"  v-if="compMode != CRUDMODE.READ">
              <span class="fa fa-plus fa-lg"></span>
            </a>
            &nbsp;
            <a href="#section" name="section" v-on:click="expandOrCollapse">
              <span class="fa fa-expand fa-lg" v-if="!localVisible" ></span>
              <span class="fa fa-compress fa-lg" v-if="localVisible"></span>
            </a>
          </div>
        </div>
        <div class="card-body" v-if="localVisible">
          <div class="row">

            <table id="dataTableEventProject" width="100%" cellspacing="0" 
                class="table table-bordered table-striped dataTable" >
             <thead>
                <tr>
                  <th width="200">{{ $t('event.form.project.type') }}</th>
                  <th>{{ $t('event.form.project.name') }}</th>
                  <th width="50" v-if="compMode != CRUDMODE.READ"></th>
                </tr>
              </thead>
              <tfoot>
                <tr>
                  <th width="200">{{ $t('event.form.project.type') }}</th>
                  <th>{{ $t('event.form.project.name') }}</th>
                  <th width="50" v-if="compMode != CRUDMODE.READ"></th>
                </tr>
              </tfoot>
              <tbody>
                <tr class="odd" v-if="eventProjects.length == 0">
                  <td valign="top" colspan="4" class="dataTables_empty">{{ $t("form.aucun_donne") }}</td>
                </tr>

                <tr v-for="(item, index) in eventProjects" v-bind:data-id="item.id" :key="item.id">
                  
                  <td>
                    <select v-model="item.projectType" :data-vv-name="'type' + index"
                        v-validate="'required'" class="form-control" id="typeInput" :placeholder="$t('event.form.project.type')">
                        <option v-for="s in projectTypes" :value="s.item1" :key="s.item1">{{s.item2}}</option>
                    </select>
                    <span class="text-danger" v-if="errors.has('type'+ index)">{{ $t('validations.required') }}</span>
                  </td>
                  <td>
                    <input v-model.trim="item.name"  name="name" v-validate="'required'" :data-vv-name="'name' + index"
                      type="text" class="form-control" id="name" :placeholder="$t('event.form.project.name')" />
                    <span class="text-danger" v-if="errors.has('name'+ index)">{{ $t('validations.required') }}</span>
                  </td>
                  <td align="center" v-if="compMode != CRUDMODE.READ">
                    <a  class="text-danger" v-bind:title="$t('form.delete_button')" href="#project" v-on:click="removeEventProject(index)">
                      <span class="fa fa-lg fa-trash"></span>
                    </a>
                  </td> 
                </tr>
              </tbody>
            </table>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {EventServiceClient, EventProjectDto} from '../../shared/service-clients/service-clients'
  import ServiceFactory from '../../shared/service-clients/serviceClientFactory'
  import CrudMixin from '../../shared/Mixin/CrudMixin'
  
  export default {
    name: 'CreateEventProject',
    props: {
      eventProjects: {},
      projectTypes: {
        type: Array,
        default: [],
      },
    },
    data() {
      return {
        localVisible: true,
      }
    },
    inject: ['$validator'],
    mixins: [CrudMixin],
    mounted: function() {
      let self = this
      setTimeout(function() {
        self.fetchData()
        self.setMode()
      }, 1000)
    },
    methods: {
      expandOrCollapse: function() {
        this.localVisible = !this.localVisible
      },
      fetchData: function() {},
      addEventProject: function() {
        let dto = new EventProjectDto()
        dto.init({})
        this.eventProjects.push(dto)
      },
      removeEventProject: function(index) {
        this.eventProjects.splice(index, 1)
      },
    },
  }
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style>
</style>



// WEBPACK FOOTER //
// src/components/events/CreateEventProject.vue